import { render, staticRenderFns } from "./ClipVue.vue?vue&type=template&id=0e8c1051&"
import script from "./ClipVue.vue?vue&type=script&lang=js&"
export * from "./ClipVue.vue?vue&type=script&lang=js&"
import style0 from "./ClipVue.vue?vue&type=style&index=0&id=0e8c1051&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports